import { render } from "./session_modal.vue?vue&type=template&id=0bb881d5"
import script from "./session_modal.vue?vue&type=script&lang=js"
export * from "./session_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__